import { adminRoutes } from 'app/constants/routes';
import { UserRoles } from 'app/constants/user';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import {
  FactorClientMatchingDashboard,
  FactorClientMatchingNext,
  FactorClientMatchingShow,
} from './FactorClientMatchingRouteComponents';

const basePath = adminRoutes.factorClientMatchings;

export const factorClientMatchingRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: FactorClientMatchingDashboard,
    path: `${basePath}/dashboard`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  {
    Component: FactorClientMatchingNext,
    path: `${basePath}/next`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  {
    Component: FactorClientMatchingShow,
    path: `${basePath}/:id`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
